export const CATEGORY_SEARCH_OPTIONS = [
  { label: "카테고리명", value: "name" },
  { label: "계정체계", value: "class" },
  { label: "코드", value: "code" },
]

export const CATEGORY_SETTINGS_OPTIONS = [
  { label: "사용", value: 0 },
  { label: "안함", value: 1 },
]
